import { Skeleton } from 'antd'
import Paper from 'components/ui/Paper'
import { FavoritesList } from 'components/utils/constants'
import React from 'react'
import { addCommas } from 'utils/shared'

const Favorites = ({ favouritesComps }) => {
    console.log("favouritesComps", favouritesComps)
    const newFavs = [
        {
            "ticker": "TSLA",
            "name": "Tesla",
            "logo": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSS05dgFYxEG1O5Bj0K2HuLEDpstMLD2njPq5qXIho6binE7yGENpz2YkimjqdPBLILRjk&usqp=CAU",
            "market_cap": 171.30,
            "day_change_percent": 1.5114096370473606
        },
        {
            "ticker": "MSFT",
            "name": "Microsoft",
            "logo": "https://www.freepnglogos.com/uploads/microsoft-window-logo-emblem-0.png",
            "market_cap": 424.44,
            "day_change_percent": -0.10588522518382353
        },
        {
            "ticker": "AAPL",
            "name": "Apple",
            "logo": "https://1000logos.net/wp-content/uploads/2016/10/Apple-Logo.png",
            "market_cap": 170.14,
            "day_change_percent": -0.21104427455834696
        }
    ]
    return (
        <Paper>
            <div className="text-xl font-bold mb-4">My Favorites</div>
            <div className="flex items-center justify-between w-full">
                {favouritesComps?.length  ?
                <>
                        {newFavs.map((item, index) => (
                        <div key={index} className="flex items-center justify-between gap-2 w-full">
                            <div className='flex items-center gap-2 text-sm sm:text-base lg:text-lg lg:gap-6 pl-2 lg:pl-6'>
                                <img src={item?.logo} width={40} height={40} alt="" />
                                <div className="flex flex-col">
                                    <div className="text-black font-semibold">
                                        {item?.ticker}
                                    </div>
                                    <div className="text-[#848484]">
                                        {item?.name}
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center text-sm lg:text-lg gap-6">
                                <div className="flex flex-col text-center">
                                    <div className="text-black font-semibold">
                                        ${item?.market_cap}
                                    </div>
                                    <div className={`${item?.day_change_percent > 0 ? 'text-[#01C0AA]' : 'text-[#EE2E6B]'} ed font-medium`}>
                                        {item?.day_change_percent?.toFixed(2)}%
                                    </div>
                                </div>
                                {index !== FavoritesList.length - 1 && (
                                    <div className="h-14 border-l-[1px] "></div>
                                )}
                            </div>
                        </div>
                    ))}
                </>
                :
                    < Skeleton paragraph={{ rows: 4 }} />
                }
            </div>
        </Paper>
    )
}

export default Favorites